export const authConfig = {
  /**
   * Application authorization details. For more information check "Getting Started" in README.md
   */
  // Specifies the environment’s UUID.
  ssoUrl: process.env.REACT_APP_SURVEY_BASE_URL,
  // Specifies the code or token type returned by an authorization request. Options are token, id_token, and code. Default values is "token id_token". This is a required property.
  responseType: "id_token token",
  //response mode
  responseMode: "fragment",
  // Specifies the application’s UUID.
  clientId: process.env.REACT_APP_CLIENT_ID,
  // Specifies the URL that specifies the return entry point of the application. This is a required property.
  redirectUri: process.env.REACT_APP_SSO_REDIRECT_URL,
  // scope: "user.read+openid+profile+email",
  scope: "profile+openid+email+api://",
  //TenantId for the SSO Login
  tenantId: process.env.REACT_APP_CLIENT_ID,
};
